import * as React from 'react';
import { Divider, Checkbox, Grid } from '@mui/material';
import { InfoListItem } from '@brightlayer-ui/react-components/core';
import { useDispatch, useSelector } from 'react-redux';
import { Selectors } from '../../selectors';
import { ChartColors, ChartColorsBackground, ChartColorsHover } from '../ReusableTrendsGraph/colors';
import { Actions } from '../../actions';
import { ActionRow } from '../OverviewCard/ActionRow';
import { AppRoute } from '../../routes';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';

export const TrendChannelList: React.FC<{
    trends: Array<{
        id: number;
        channelName: string;
        deviceId: string;
        deviceName: string;
        value: Array<{
            dateTime: string;
            value: string;
        }>;
        unit: string | null;
        isSelected?: boolean;
    }>;
    viewTrendviewerAppRoute?: AppRoute;
    large?: boolean;
    count: Function;
    selectedChannel: Function;
}> = (props) => {
    const { t } = useLanguageLocale();
    const dispatch = useDispatch();
    const [channelList, setChannelList] = React.useState<any[]>([]);
    const [channelChecked, setChannelChecked] = React.useState(1);
    //const [data, setData] = React.useState(0);
    //const trendLinesEnabled = useSelector(Selectors.Dashboard.trendLinesEnabled);
    const hoveredTrendline = useSelector(Selectors.Dashboard.hoveredTrendline);
    const convertHex = (hex: string, opacity: number): string => {
        const newhex = hex.replace('#', '');
        const r = parseInt(newhex.substring(0, 2), 16);
        const g = parseInt(newhex.substring(2, 4), 16);
        const b = parseInt(newhex.substring(4, 6), 16);

        return `rgba(${r},${g},${b},${opacity / 100})`;
    };

    React.useEffect(() => {
        let sum = 0;
        channelList.map((x) => {
            if (x.checked === true) sum++;
        });
        const channelCheck = sum;
        //const channels1: any = channels.map((x) =>
        //x.filter((x1: any) => x1.checked === true)
        props.count(channelCheck);
    }, [props, channelList]);

    React.useEffect(() => {
        const list = props.trends.map((elem: any, index: number) => ({
            ...elem,
            checked: elem.isSelected && index < 10 ? true : false,
            color: ChartColors[index % ChartColors.length],
        }));
        setChannelList(list);
        const checkedChannel = list.filter((x) => x.checked === true);
        setChannelChecked(checkedChannel.length);
        props.selectedChannel(checkedChannel);
    }, [props.trends]);

    React.useEffect(() => {
        const selectedChannels: Array<{ id: string; name: string }> = [];
        props.trends.map((trendData) =>
            selectedChannels.push({ id: trendData.id.toString(), name: trendData.channelName })
        );
        //dispatch(Actions.TrendChannels.trendChannelsSelected(selectedChannels));
        dispatch(Actions.Dashboard.trendListItemCheckboxClear());
    }, [props.trends, dispatch]);

    React.useEffect(() => {
        const channels1: any = channelList.map((x) =>
            //x.filter((x1: any) => x1.checked === true)
            x.checked === true ? x : ''
        );
        dispatch(Actions.TrendChannels.trendChannelsSelected(channels1));
        //dispatch(Actions.Dashboard.trendListItemCheckboxClear());
    }, [channelList, dispatch]);

    const onClick = (channel: any): void => {
        const channels = channelList.map((x) =>
            x.id === channel.id && x.deviceId === channel.deviceId ? { ...x, checked: !channel.checked } : x
        );

        const checkedChannel = channels.filter((x) => x.checked === true);
        setChannelChecked(checkedChannel.length);
        if (checkedChannel && checkedChannel.length <= 10) {
            dispatch(Actions.Dashboard.trendListItemCheckboxClicked(channel.id, channel.deviceId));
            setChannelList(channels);
            props.selectedChannel(checkedChannel);
        }
    };

    if (props.large) {
        return (
            <>
                {/* <List
            subheader={
               <ReusableTrendsCardHeader title={t('DASHBOARD.SITE_DETAILS.TRENDS_CARD.TITLE')} count={channelChecked}>
                </ReusableTrendsCardHeader>
                }
                ></List> */}
                <div>
                    <Divider />
                    {channelList.map((trendDatum, index) => (
                        <div
                            data-testid="trend-list-item"
                            key={index}
                            onMouseEnter={(): void => {
                                dispatch(Actions.Dashboard.trendListItemEntered(trendDatum.id, trendDatum.deviceId));
                            }}
                            onMouseLeave={(): void => {
                                dispatch(Actions.Dashboard.trendListItemLeft());
                            }}
                        >
                            <InfoListItem
                                disabled={trendDatum.checked === false && channelChecked >= 10}
                                title={trendDatum.channelName}
                                subtitle={trendDatum.deviceName}
                                backgroundColor={
                                    hoveredTrendline &&
                                    trendDatum.id === hoveredTrendline.channelId &&
                                    trendDatum.deviceId === hoveredTrendline.deviceId
                                        ? convertHex(ChartColorsHover[index % ChartColorsHover.length], 5)
                                        : convertHex(ChartColorsBackground[index % ChartColorsBackground.length], 3)
                                }
                                icon={
                                    <Checkbox
                                        data-testid="trend-item-checkbox"
                                        checked={trendDatum.checked} //isTrendlineEnabled(trendLinesEnabled, trendDatum.id, trendDatum.deviceId, trendDatum.checked)}
                                        style={{ color: ChartColors[index % ChartColors.length] }}
                                        disableRipple
                                    />
                                }
                                statusColor={ChartColors[index % ChartColors.length]}
                                divider={index + 1 < props.trends.length ? 'full' : undefined}
                                onClick={(): void => {
                                    onClick(trendDatum);
                                }}
                            />
                        </div>
                    ))}
                    {props.viewTrendviewerAppRoute && (
                        <>
                            <Divider />

                            <ActionRow
                                appRoute={props.viewTrendviewerAppRoute}
                                label={t('DASHBOARD.SITE_DETAILS.TRENDS_CARD.VIEW_ALL')}
                            />
                        </>
                    )}
                </div>
            </>
        );
    }
    return (
        <>
            {/* <List
        subheader={
           <ReusableTrendsCardHeader title={t('DASHBOARD.SITE_DETAILS.TRENDS_CARD.TITLE')} count={channelChecked}>
            </ReusableTrendsCardHeader>
            }
            ></List> */}
            <div>
                <Divider />
                <Grid container>
                    {channelList.map((trendDatum, index) => (
                        <Grid item sm={6} key={index}>
                            <div
                                data-testid="trend-list-item"
                                onMouseEnter={(): void => {
                                    dispatch(
                                        Actions.Dashboard.trendListItemEntered(trendDatum.id, trendDatum.deviceId)
                                    );
                                }}
                                onMouseLeave={(): void => {
                                    dispatch(Actions.Dashboard.trendListItemLeft());
                                }}
                            >
                                <InfoListItem
                                    disabled={trendDatum.checked === false && channelChecked >= 10}
                                    title={trendDatum.channelName}
                                    subtitle={trendDatum.deviceName}
                                    backgroundColor={
                                        hoveredTrendline &&
                                        trendDatum.id === hoveredTrendline.channelId &&
                                        trendDatum.deviceId === hoveredTrendline.deviceId
                                            ? convertHex(ChartColorsHover[index % ChartColorsHover.length], 5)
                                            : convertHex(ChartColorsBackground[index % ChartColorsBackground.length], 3)
                                    }
                                    icon={
                                        <Checkbox
                                            //disabled={disabledChannel()}
                                            data-testid="trend-item-checkbox"
                                            checked={trendDatum.checked} //isTrendlineEnabled(trendLinesEnabled, trendDatum.id, trendDatum.deviceId,trendDatum.checked)}
                                            style={{ color: ChartColors[index % ChartColors.length] }}
                                            disableRipple
                                        />
                                    }
                                    statusColor={ChartColors[index % ChartColors.length]}
                                    divider={index + 1 < props.trends.length ? 'full' : undefined}
                                    onClick={(): void => {
                                        onClick(trendDatum);
                                    }}
                                />
                            </div>
                        </Grid>
                    ))}
                </Grid>
                {props.viewTrendviewerAppRoute && (
                    <>
                        <Divider />

                        <ActionRow
                            appRoute={props.viewTrendviewerAppRoute}
                            label={t('DASHBOARD.SITE_DETAILS.TRENDS_CARD.VIEW_ALL')}
                        />
                    </>
                )}
            </div>
        </>
    );
};
